
  import ScreenSize from '@/mixins/ScreenSize';
  export default {
    name: 'SectionHeadlineWithTextAndIcons',
    components: {
      CustomIcon: () => import('@/components/elements/CustomIcon'),
    },
    mixins: [ScreenSize],
    props: {
      section: {
        type: Object,
        required: false,
        default: () => {},
      },
    },
    serverCacheKey: function (props) {
      return 'section-headline-with-text-and-icons-' + props.section.id;
    },
    data() {
      return {
        model: null,
        iconWidth: 250,
      };
    },
    watch: {
      '$vuetify.breakpoint.width'() {
        this.setSliderWidth();
      },
    },
    mounted() {
      this.setSliderWidth();
    },
    methods: {
      setSliderWidth() {
        const slider = document.querySelector('.pb-icon-slider');
        if (
          slider &&
          this.$vuetify.breakpoint.width >
            this.$vuetify.breakpoint.thresholds.sm
        ) {
          const width = slider.offsetWidth;
          this.iconWidth = width / this.section.icons.length;
        }
      },
      columnSizes(index) {
        let mobileColumn;
        if (
          this.$vuetify.breakpoint.width <=
            this.$vuetify.breakpoint.thresholds.sm &&
          this.section.icons.length % 2 !== 0 &&
          index < this.section.icons.length - 1
        ) {
          mobileColumn = 6;
        } else if (
          this.$vuetify.breakpoint.width <=
            this.$vuetify.breakpoint.thresholds.sm &&
          this.section.icons.length % 2 !== 0 &&
          index === this.section.icons.length - 1
        ) {
          mobileColumn = 12;
        } else if (
          this.$vuetify.breakpoint.width <=
            this.$vuetify.breakpoint.thresholds.sm &&
          this.section.icons.length % 2 === 0
        ) {
          mobileColumn = 6;
        }
        return this.$vuetify.breakpoint.width >
          this.$vuetify.breakpoint.thresholds.sm
          ? ''
          : mobileColumn;
      },
    },
  };
